import { useEffect, useRef, useState } from "react";

interface VisibleElement {
  [key: string]: boolean;
}

interface Counter {
  [key: string]: number;
}

export default function Stats() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState<VisibleElement>({});
  const [counters, setCounters] = useState<Counter>({
    employees: 0,
    teams: 0,
    partners: 0,
    capital: 0,
  });
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setVisible({ main: true });
          
          setCounters({
            employees: 0,
            teams: 0,
            partners: 0,
            // capital: 0,
          });
          
          setTimeout(() => {
            setCounters({
              employees: 2,
              teams: 3,
              partners: 5,
              // capital: 0,
            });
          }, 500);
          
          setHasAnimated(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [hasAnimated]);

  return (
    <section
      ref={sectionRef}
      className="relative w-full py-4 pt-12 bg-black border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6">
        <p
          className={`text-white/50 text-sm font-light mb-8 tracking-widest transition-all duration-700 ${
            visible.main ? "animate-fade-in-up" : "opacity-0"
          }`}
        >
          <div className="inline-block px-4 py-2 bg-white/5 border border-white/20 rounded-full text-sm text-gray-300">
            COMPANY
          </div>
        </p>

        <h2
          className={`text-white text-5xl md:text-6xl font-light leading-tight mb-16 transition-all duration-700 ${
            visible.main ? "animate-fade-in-up" : "opacity-0"
          }`}
        >
          Devananta R&D in Numbers
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-8 md:gap-12">
          {[
            { label: "Patents", value: counters.employees },
            { label: "Collaboration", value: counters.teams },
            { label: "R&D Workforce", value: counters.partners },
            // { label: "Certifications", value: counters.capital },
          ].map((stat, index) => (
            <div
              key={index}
              className={`transition-all duration-700 ${
                visible.main ? "animate-fade-in-up" : "opacity-0"
              }`}
            >
              <div className="border-b border-white/20 pb-6 mb-4">
                <p 
                  className={`text-white text-5xl md:text-6xl font-light transition-all duration-300 ${
                    counters.employees === 4 ? "scale-105" : "scale-100"
                  }`}
                >
                  {stat.value}
                </p>
              </div>
              <p className="text-white/60 text-sm font-light">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div
        className={`transition-all duration-700 ${
          visible.main ? "animate-fade-in-up" : "opacity-0"
        }`}
      >
        <video
          src="/devanantarndfacilityvideo.mp4"
          autoPlay
          loop
          muted
          className="w-full h-[500px] object-cover rounded-lg"
        ></video>
      </div>
    </section>
  );
}